
   import {defineComponent} from 'vue'
   export default defineComponent({
    name:"TanChuang",
    props:{
        content:{
            type:String,
            required:true,
            default:"弹窗信息" 
        },
        showno:{
            type:String,
            required:true,
            defalut:'tanchuangno'
        } 
    }    
   })
